import * as React from 'react';
import ReactDOM from 'react-dom';

import { Box } from '@lightspeed/flame/Core';

import BaseItemView from 'app/src/views/base/BaseItemView';
import { createReactRenderer } from 'root/apps/helpers/react-renderer';
import PaymentSavedCards from 'root/apps/payments/PaymentSavedCards';

const RenderedComponent = createReactRenderer({
  component: PaymentSavedCards,
  selector: '#payments_content>div:first-of-type',
});

const View = BaseItemView.extend({
  template: false,
  onRender() {
    RenderedComponent.mount({
      props: {
        viewData: this.viewData,
        saleManager: this.saleManager,
      },
    });
  },
  onDestroy() {
    RenderedComponent.unmount();
  },
});

export default class PaymentSavedCardsView extends View {
  constructor(props) {
    super(props);
    this.viewData = props.viewData;
    this.saleManager = props.saleManager;
  }
}
